interface TotalPaymentsPreview {
  enrollmentId?: string;
  totalPayments?: number;
  totalAmount?: number;
  payments?: Array<{ amount: number }>;
}

export function isEnrollmentPaymentsForClass(
  totalPayments: TotalPaymentsPreview | undefined,
  enrollmentId: string | undefined,
): boolean {
  if (!enrollmentId || !totalPayments) {
    return false;
  }
  const responseEnrollmentId = totalPayments.enrollmentId ?? enrollmentId;
  return String(responseEnrollmentId) === String(enrollmentId);
}

export function isHourlyLastMonthEnrollment(
  classDetails:
    | {
        tuitionBillingCycle?: string;
        session?: { chargeLastMonthAtCheckout?: boolean };
      }
    | null
    | undefined,
): boolean {
  return (
    classDetails?.tuitionBillingCycle === 'hourly' &&
    !!classDetails?.session?.chargeLastMonthAtCheckout
  );
}

export function isHourlyFirstMonthEnrollment(
  classDetails:
    | {
        tuitionBillingCycle?: string;
        session?: { chargeFirstMonthHourlyAtCheckout?: boolean };
      }
    | null
    | undefined,
): boolean {
  return (
    classDetails?.tuitionBillingCycle === 'hourly' &&
    !!classDetails?.session?.chargeFirstMonthHourlyAtCheckout
  );
}

export function resolveHourlyLastMonthPreviewAmount(
  totalPayments: TotalPaymentsPreview | undefined,
  enrollmentId: string | undefined,
): number | undefined {
  if (!isEnrollmentPaymentsForClass(totalPayments, enrollmentId)) {
    return undefined;
  }
  if (totalPayments?.totalAmount != null) {
    return totalPayments.totalAmount;
  }
  const payments = totalPayments?.payments;
  if (!payments?.length) {
    return undefined;
  }
  return payments[payments.length - 1]?.amount;
}

/** Sum per-student incremental previews after all queries have settled (ENR-1331). */
export function sumHourlyLastMonthPreviewAmounts(
  amounts: Array<number | undefined>,
  settled: boolean,
): number | undefined {
  if (!settled) {
    return undefined;
  }
  return amounts.reduce((sum, amount) => sum + (amount ?? 0), 0);
}

/** Tuition subtotal from a V2 preview charge for the enroll summary. */
export function resolveHourlyFirstMonthPreviewTuition(
  charges:
    | Array<{ studentId: string; tuitionSubtotal?: number }>
    | undefined,
  studentId: string | undefined,
): number | undefined {
  if (!studentId || !charges?.length) return undefined;
  const charge = charges.find((row) => row.studentId === studentId);
  if (charge?.tuitionSubtotal == null) return undefined;
  return charge.tuitionSubtotal;
}
